<template>
    <div v-if="is_legacy" class="form-row mb-4">
        <div class="col-12 col-xl-6">
            <v-hotel-manager @hotel_change="hotel_change(hotel_placement.id)" :hotel_placement="hotel_placement" :is_legacy="is_legacy"></v-hotel-manager>

            <div class="form-row">
                <div class="col">
                    <div class="form-group">
                        <label class="form-control-wrap">Price Range</label>
                        <div class="form-control-wrap form-control-currency">
                            <i class="fas fa-dollar-sign"></i>
                            <v-currency v-model="hotel_placement.price" name="price" class="form-control"></v-currency>
                        </div>
                        <small class="form-text text-danger">Value is invalid.</small>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label class="form-control-wrap"></label>
                        <div class="form-control-wrap form-control-currency">
                            <i class="fas fa-dollar-sign"></i>
                            <v-currency v-model="hotel_placement.price_high" name="price_high" class="form-control"></v-currency>
                        </div>
                        <small class="form-text text-danger">Value is invalid.</small>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col-12 col-xl-6 align-items-baseline">
                    <div class="form-group">
                        <v-counter classes="form-control" name="" label="# of Rooms" step="1" min="0" max="10" v-model="hotel_placement.room_count" :clone="room_clone(hotel_placement.id)" :arr="hotel_placement.rooms"></v-counter>
                        <small class="form-text text-danger">Value Is Invalid</small>
                    </div>
                </div>
                <div class="col-12 col-xl-6">
                    <div action="/api/hotel_placement_room/update" class="form-row live-form" v-for="room in hotel_placement.rooms">
                        <div class="col">
                            <div class="form-group">
                                <v-layout-select label="Room Type" name="room_type_id" :options="options.room_types" :model.sync="room.room_type_id"></v-layout-select>
                            </div>
                        </div>
                        <div class="col" v-if="room.room_type_id == 4">
                            <div class="form-group">
                                <v-layout-text
                                    label="Custom Room Type"
                                    name="custom_room_type"
                                    :model.sync="room.custom_room_type"
                                ></v-layout-text>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <v-layout-text
                                    label="Bed Configuration"
                                    name="bed_configuration"
                                    :model.sync="room.bed_configuration"
                                ></v-layout-text>
                            </div>
                        </div>
                        <v-hidden v-model="room.id" class="form-control" name="id"></v-hidden>
                    </div>
                </div>
            </div>

            <div class="form-row my-2">
                <div class="col-12 col-xl-6">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <v-layout-select label="IATA" name="iata" classes="form-control" :options="options.confirm" :model.sync="hotel_placement.iata"></v-layout-select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label>IATA #</label>
                                <div v-if="settings.iata_number">
                                    <span class="badge badge-gray">{{ settings.iata_number }}</span>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-6">
                    <div class="form-row">
                        <div class="col-12">
                            <div class="form-group">
                                <v-layout-textarea
                                    label="IATA Notes"
                                    name="iata_notes"
                                    :model.sync="hotel_placement.iata_notes"
                                    rows="3"
                                ></v-layout-textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row mb-5">
                <div class="col">
                    <div class="form-group">
                        <v-layout-text
                            label="Confirmation #"
                            name="confirmation_no"
                            :model.sync="hotel_placement.confirmation_no"
                        ></v-layout-text>
                    </div>
                </div>
            </div>

            <div class="form-row">
                <div class="col-12 mb-2">
                    <div class="collapse" :id="'hotel-filemanager-' + hotel_placement.id">
                        <iframe class="filemanager-display border"
                            :src="'/tps-filemanager?id=' + placement.id + '&type=hotel&hotel_placement_id=' + hotel_placement.id"
                            style="width: 100%; height: 450px; overflow: hidden; border: none;">
                        </iframe>
                    </div>

                    <button v-if="!placement.archived" class="btn btn-primary" type="button" data-toggle="collapse"
                        :data-target="'#hotel-filemanager-' + hotel_placement.id" aria-expanded="false"
                        :aria-controls="'hotel-filemanager-' + hotel_placement.id">Toggle Filemanager</button>
                </div>
                <div class="col-12 mb-2">
                    <div class="btn-group dropdown">
                        <button type="button" class="btn btn-primary archive-skip"
                            @click="copyClipboard('hotelInfo', hotel_placement, true)">
                            Copy To Clipboard - Hotel Information
                        </button>
                        <button type="button"
                            class="btn btn-primary dropdown-toggle dropdown-toggle-split archive-skip"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Option</span>
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item archive-skip" type="button"
                                @click="copyClipboard('hotelInfo', hotel_placement, false)">
                                Copy as Text
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <div class="btn-group dropdown">
                        <button type="button" class="btn btn-primary archive-skip"
                            @click="copyClipboard('adjusterUpdate', hotel_placement, true)">
                            Copy To Clipboard - Adjuster Update
                        </button>
                        <button type="button"
                            class="btn btn-primary dropdown-toggle dropdown-toggle-split archive-skip"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Option</span>
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item archive-skip" type="button"
                                @click="copyClipboard('adjusterUpdate', hotel_placement, false)">
                                Copy as Text
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <button class="btn btn-warning archive-skip" type="button" :data-id="'hotel-migrate-' + hotel_placement.id" @click="migrate_hotel(placement, hotel_placement)">
                        Migrate Hotel Data
                    </button>
                </div>
            </div>
        </div>

        <div class="col-xs-12 col-xl-6">
            <div class="form-row">
                <div class="col-12">
                    <div class="form-row">
                        <div class="col-6">
                            <div class="form-group">
                                <label :class="{ 'form-input-readonly bg-white': false }">Check In Date</label>
                                <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                                    <v-datepicker v-model="hotel_placement.check_in_date" v-tooltip="hotel_placement.check_in_date" type="text" name="check_in_date" autocomplete="off" class="form-control datepicker" value="" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                                    <span class="form-control-date-custom "></span>
                                </div>
                                <small id="" class="form-text text-danger">Value is invalid.</small>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label :class="{ 'form-input-readonly bg-white': false }">Check Out Date</label>
                                <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                                    <v-datepicker v-model="hotel_placement.check_out_date" v-tooltip="hotel_placement.check_out_date" type="text" name="check_out_date" autocomplete="off" class="form-control datepicker" value="" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                                    <span class="form-control-date-custom "></span>
                                </div>
                                <small class="form-text text-danger">Value is invalid.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="form-row">
                <div class="col-6">
                    <div class="form-group">
                        <v-layout-select label="Card On File" name="card_id" classes="form-control" :options="options.cards" :model.sync="hotel_placement.card_id"></v-layout-select>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label :class="{ 'form-input-readonly bg-white': false }">Hotel Secured Through</label>
                        <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                            <v-datepicker v-model="hotel_placement.secured_through" v-tooltip="hotel_placement.secured_through" type="text" name="secured_through" autocomplete="off" class="form-control datepicker" value="" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                            <span class="form-control-date-custom "></span>
                        </div>
                        <small class="form-text text-danger">Value is invalid.</small>
                    </div>
                </div>
                <div class="col-6"
                    v-if="options.cards.find(card => card.id == hotel_placement.card_id) && options.cards.find(card => card.id == hotel_placement.card_id).text === 'Virtual Card'">
                    <div class="form-group">
                        <v-layout-select label="Which Virtual Card?" name="virtual_card_id" classes="form-control" :options="options.virtual_cards" :model.sync="hotel_placement.virtual_card_id"></v-layout-select>
                    </div>
                </div>
            </div>
    
            <div class="form-row">
                <div class="col-6">
                    <div class="form-group">
                        <div class="form-check " tabindex="0" :class="{ 'form-input-readonly': false }">
                            <v-checkbox v-model="placement.quickbooks" class="form-check-input" name="quickbooks"></v-checkbox>
                            <label class="form-check-label">
                                <div class="form-check-label-inner">In Quickbooks</div>
                                <span class="form-check-custom"></span>
                            </label>
                        </div>
                        <small class="form-text text-danger">Value is invalid.</small>
                    </div>
                </div>
            </div>
    
            <div class="form-row">
                <div class="col-12">
                    <div v-if="!hotel_placement.invoice_requests.length">
                        <button class="btn btn-secondary px-2 py-1" type="button"
                            @click="clone_create('/api/invoice_request/create', {'placement_id':placement.id, 'hotel_placement_id':hotel_placement.id, 'created_from': 'hotel_placement'}, hotel_placement.invoice_requests, model)">
                            <i class="fas fa-plus"></i> Add Invoice Request
                        </button>
                    </div>

                    <v-hotel-invoice-requests
                        v-for="(invoice_request, invoice_request_index) in hotel_placement.invoice_requests"
                        :hotel_placement="hotel_placement"
                        :model="model"
                        :invoice_requests="hotel_placement.invoice_requests"
                        :invoice_request="invoice_request"
                        :invoice_request_index="invoice_request_index"
                        :key="invoice_request_index"
                    ></v-hotel-invoice-requests>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="form-row mb-4">
        <div class="col-12" :class="{ 'col-xl-6': !is_migrating }">
            <div class="row mb-4">
                <div class="col-12">
                    <v-hotel-manager @hotel_change="hotel_change(hotel_placement.id)" :hotel_placement="hotel_placement" :is_legacy="is_legacy"></v-hotel-manager>
                </div>
            </div>

            <div class="row px-2" v-if="!is_migrating">
                <div class="col-12 mb-2">
                    <div class="collapse" :id="'hotel-filemanager-' + hotel_placement.id">
                        <iframe class='filemanager-display border'
                            :src="'/tps-filemanager?id=' + placement.id + '&type=hotel&hotel_placement_id=' +
                                hotel_placement.id"
                            style="width: 100%; height: 450px; overflow: hidden; border: none;">
                        </iframe>
                    </div>

                    <button v-if="!placement.archived" class="btn btn-primary" type="button"
                        data-toggle="collapse" :data-target="'#hotel-filemanager-' + hotel_placement.id"
                        aria-expanded="false" :aria-controls="'hotel-filemanager-' + hotel_placement.id">Toggle Filemanager</button>
                </div>
                <div class="col-12 mb-2">
                    <div class="btn-group dropdown">
                        <button type="button" class="btn btn-primary archive-skip"
                            @click="copyClipboard('hotelInfo', hotel_placement, true)">
                            Copy To Clipboard - Hotel Information
                        </button>
                        <button type="button"
                            class="btn btn-primary dropdown-toggle dropdown-toggle-split archive-skip"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Option</span>
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item archive-skip" type="button"
                                @click="copyClipboard('hotelInfo', hotel_placement, false)">Copy as Text</button>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-2">
                    <div class="btn-group dropdown">
                        <button type="button" class="btn btn-primary archive-skip"
                            @click="copyClipboard('adjusterUpdate', hotel_placement, true)">
                            Copy To Clipboard - Adjuster Update
                        </button>
                        <button type="button"
                            class="btn btn-primary dropdown-toggle dropdown-toggle-split archive-skip"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="sr-only">Toggle Option</span>
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item archive-skip" type="button"
                                @click="copyClipboard('adjusterUpdate', hotel_placement, false)">Copy as
                                Text</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" :class="{ 'col-xl-6': !is_migrating }">
            <div class="card rounded-0 mb-4">
                <div class="card-header rounded-0">
                    Reservation Details
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-xl-6">
                            <div class="form-group">
                                <v-counter classes="form-control" name="" label="# of Rooms" step="1" min="1" max="10" v-model="hotel_placement.room_count" :overlay="roomCount" :clone="room_clone(hotel_placement.id)" :arr="hotel_placement.rooms"></v-counter>
                                <small class="form-text text-danger">Value Is Invalid</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="live-form card rounded-0 mb-4" action="/api/hotel_placement_room/update"
                v-for="(room, key) in hotel_placement.rooms">
                <div class="card-header rounded-0">
                    <div class="row">
                        <div class="col-9 d-flex flex-wrap align-items-center pr-0 pl-2">
                            <span>Room {{ key + 1 }}: {{ room.name_on_reservation }} Completed as of: </span>
                            <div class="ml-2">
                                <div class="form-control-wrap form-datepicker text-white">
                                    <v-datepicker v-model="room.completed_date" type="text" name="completed_date" autocomplete="off" class="form-control border-bottom border-white text-white datepicker" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                                    <span class="form-control-date-custom text-white bg-transparent border-bottom border-white"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col text-right justify-content-end">
                            <button
                                v-tooltip="'Minimize Hotel Room.'"
                                class="btn btn-link py-0"
                                :class="{ collapsed: !!room.completed_date }"
                                data-toggle="collapse"
                                :aria-expanded="!room.completed_date ? 'false' : 'true'"
                                :data-target="`#hotel-room-${room.id}`"
                                :aria-controls="`hotel-room-${room.id}`"
                            ></button>
                        </div>
                    </div>
                </div>
                <div :id="'hotel-room-' + room.id" class="card-body collapse" :class='{ "disabled": !!room.completed_date, "show": !room.completed_date }'>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-row">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group">
                                        <label :class="{ 'form-input-readonly bg-white': false }">Check In Date</label>
                                        <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                                            <v-datepicker v-model="room.check_in_date" v-tooltip="room.check_in_date" type="text" name="check_in_date" autocomplete="off" class="form-control datepicker" value="" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                                            <span class="form-control-date-custom "></span>
                                        </div>
                                        <small id="" class="form-text text-danger">Value is invalid.</small>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6">
                                    <div class="form-group">
                                        <label :class="{ 'form-input-readonly bg-white': false }">Check Out Date</label>
                                        <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                                            <v-datepicker v-model="room.check_out_date" v-tooltip="room.check_out_date" type="text" name="check_out_date" autocomplete="off" class="form-control datepicker" value="" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                                            <span class="form-control-date-custom "></span>
                                        </div>
                                        <small id="" class="form-text text-danger">Value is invalid.</small>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col-12 col-xl-6">
                                    <div class="form-group">
                                        <label class="form-control-wrap">Number of Nights</label>
                                        <div class="form-control-wrap">
                                            <span
                                                class="badge-gray form-control alphanumeric-field">{{ number_of_nights(room.check_in_date, room.check_out_date) }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-xl-6">
                                    <div class="form-group">
                                        <label :class="{ 'form-input-readonly bg-white': false }">Room Secured Through</label>
                                        <div class="form-control-wrap form-datepicker " :class="{ 'form-input-readonly': false }">
                                            <v-datepicker v-model="room.secured_through" v-tooltip="room.secured_through" type="text" name="secured_through" autocomplete="off" class="form-control datepicker" value="" :disable="false" pattern="(0[1-9]|1[012]|[1-9])[- /.](0[1-9]|[12][0-9]|3[01]|[1-9])[- /.]((18|19|20)\d\d|\d\d)"></v-datepicker>
                                            <span class="form-control-date-custom "></span>
                                        </div>
                                        <small id="" class="form-text text-danger">Value is invalid.</small>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col-12 col-xl-6">
                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <v-layout-text
                                                    label="Name on Reservation"
                                                    name="name_on_reservation"
                                                    :model.sync="room.name_on_reservation"
                                                ></v-layout-text>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <v-layout-select label="Room Type" name="room_type_id" :options="options.room_types" :model.sync="room.room_type_id"></v-layout-select>
                                            </div>
                                        </div>
                                        <div class="col" v-if="room.room_type_id == 4">
                                            <div class="form-group">
                                                <v-layout-text
                                                    label="Custom Room Type"
                                                    name="custom_room_type"
                                                    :model.sync="room.custom_room_type"
                                                ></v-layout-text>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <v-layout-text
                                                    label="Bed Configuration"
                                                    name="bed_configuration"
                                                    :model.sync="room.bed_configuration"
                                                ></v-layout-text>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-control-wrap">Price Range</label>
                                                <div class="form-control-wrap form-control-currency">
                                                    <i class="fas fa-dollar-sign"></i>
                                                    <v-currency v-model="room.price" name="price" class="form-control"></v-currency>
                                                </div>
                                                <small class="form-text text-danger">Value is invalid.</small>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label class="form-control-wrap"></label>
                                                <div class="form-control-wrap form-control-currency">
                                                    <i class="fas fa-dollar-sign"></i>
                                                    <v-currency v-model="room.price_high" name="price_high" class="form-control"></v-currency>
                                                </div>
                                                <small class="form-text text-danger">Value is invalid.</small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <v-counter classes="form-control" name="pet_count"
                                                    label="# of Pets" step="1" min="0"
                                                    max="100" v-model="room.pet_count">
                                                </v-counter>
                                                <small class="form-text text-danger">Value Is Invalid</small>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <v-counter classes="form-control" name="parking_valet_count"
                                                    label="# of Valet Parking" step="1" min="0"
                                                    max="100" v-model="room.parking_valet_count">
                                                </v-counter>
                                                <small class="form-text text-danger">Value Is Invalid</small>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <v-counter classes="form-control" name="parking_self_count"
                                                    label="# of Self Parking" step="1" min="0"
                                                    max="100" v-model="room.parking_self_count">
                                                </v-counter>
                                                <small class="form-text text-danger">Value Is Invalid</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 col-xl-6">
                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <v-layout-text
                                                    label="Confirmation #"
                                                    name="confirmation_no"
                                                    :model.sync="room.confirmation_no"
                                                ></v-layout-text>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <v-layout-text
                                                    label="Room #"
                                                    name="room_no"
                                                    :model.sync="room.room_no"
                                                ></v-layout-text>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col">
                                            <div class="form-group">
                                                <v-layout-select label="Kitchen?" name="kitchen" :options="options.confirm" :model.sync="room.kitchen"></v-layout-select>
                                            </div>
                                        </div>
                                        <div class="col" v-if="room.kitchen == 1">
                                            <div class="form-group">
                                                <v-layout-select label="Kitchen Type" name="kitchen_type" :options="options.kitchen_types_yes" :model.sync="room.kitchen_type"></v-layout-select>
                                            </div>
                                        </div>
                                        <div class="col" v-else>
                                            <div class="form-group">
                                                <v-layout-select label="Kitchen Type" name="kitchen_type" :options="options.kitchen_types_no" :model.sync="room.kitchen_type"></v-layout-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <v-layout-select label="Card On File" name="card_id" :options="options.cards" :model.sync="room.card_id"></v-layout-select>
                                            </div>
                                        </div>
                                        <div class="col-12"
                                            v-if="options.cards.find(card => card.id == room.card_id) && options.cards.find(card => card.id == room.card_id).text === 'Virtual Card'">
                                            <div class="form-group">
                                                <v-layout-select label="Which Virtual Card?" name="virtual_card_id" :options="options.virtual_cards" :model.sync="room.virtual_card_id"></v-layout-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label>IATA <span v-if="settings.iata_number" class="badge badge-gray">{{ settings.iata_number }}</span></label>
                                                <v-layout-select label="" name="iata" :options="options.confirm" :model.sync="room.iata"></v-layout-select>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <v-layout-textarea
                                                    label="IATA Notes"
                                                    name="iata_notes"
                                                    :model.sync="room.iata_notes"
                                                    rows="3"
                                                ></v-layout-textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <v-layout-select label="Marriot Concierge Program" name="marriot_concierge_program" :options="options.confirm" :model.sync="room.marriot_concierge_program"></v-layout-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-row my-4 room-invoices" v-if="!is_migrating">
                                <div class="col-12">
                                    <div v-if="!room.invoice_requests.length">
                                        <button class="btn btn-secondary px-2 py-1" type="button"
                                            @click="clone_create('/api/invoice_request/create', {'placement_id':placement.id, 'hotel_placement_id':hotel_placement.id, 'hotel_placement_room_id':room.id, 'created_from': 'hotel_placement'}, room.invoice_requests, model)">
                                            <i class="fas fa-plus"></i> Add Invoice Request
                                        </button>
                                    </div>

                                    <v-hotel-invoice-requests
                                        v-for="(invoice_request, invoice_request_index) in room.invoice_requests"
                                        :hotel_placement="hotel_placement"
                                        :model="model"
                                        :invoice_requests="room.invoice_requests"
                                        :invoice_request="invoice_request"
                                        :invoice_request_index="invoice_request_index"
                                        :key="invoice_request_index"
                                        :room="room"
                                    ></v-hotel-invoice-requests>
                                </div>
                            </div>
                        </div>
                        <v-hidden v-model="room.id" class="form-control" name="id"></v-hidden>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "placement",
        "hotel_placement",
        "is_legacy",
        "model",
        "is_migrating",
    ],
    data() {
        return {
            id: this.hotel_placement.id,
            options: window.app_options,
            settings: window.app_data.settings,
        };
    },
    methods: {
        copyClipboard(type, hotelPlacement, asEmail = false) {
            this.$parent.copyClipboard(type, hotelPlacement, asEmail);
        },
        clone_create(url, post_data, arr, model) {
            this.$parent.clone_create(url, post_data, arr, model);
        },
        clone_remove(url, item, arr, index) {
            this.$parent.clone_remove(url, item, arr, index);
        },
        hotel_change(id) {
            this.$parent.hotel_change(id);
        },
        migrate_hotel(placement, hotelPlacement) {
            this.$parent.migrate_hotel(placement, hotelPlacement);
        },
        room_clone(id) {
            return this.$parent.room_clone(id);
        },
        number_of_nights(checkin, checkout) {
            return checkout && checkin ? moment(checkout).diff(moment(checkin), 'days') : 0;
        },
    },
    computed: {
        roomCount() {
            const rooms = this.hotel_placement.rooms ? this.hotel_placement.rooms.filter(r => !r.completed_date) : [];
            return rooms.length;
        }, 
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/placement/hotel-placement.vue